/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-01 18:08:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:15:14
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/LegalCategory/CollapseGroupContainer/index.tsx
 */

import Node from '../Node';
import { getOrder } from '../slice';
import { groupGenerate as _groupGenerate } from 'src/pages/SalesChannelCategory/Components/CollapseGroupContainer';
const groupGenerate = ({ salesChannelUuid, userPermissions }) => {
  return _groupGenerate({ salesChannelUuid, userPermissions, Node, getOrder });
};
export default groupGenerate;
